import type {
  MutationKey,
  QueryKey,
  QueryOptions,
} from '@tanstack/react-query';

type AnyshiftMutationKeyItem = MutationKey[number] & {
  action: string;
  invalidate: boolean;
};

type AnyshiftMutationKey = [...MutationKey, AnyshiftMutationKeyItem];

export const generateMutationKey = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  query: QueryKey | QueryOptions<any, any, any, any>,
  action: string,
  invalidate = false,
): AnyshiftMutationKey => {
  if (Array.isArray(query)) {
    return [...(query as QueryKey), { action, invalidate }];
  }

  return [...((query as QueryOptions).queryKey ?? []), { action, invalidate }];
};

export const parseMutationKey = (
  mutationKey: MutationKey,
): { queryKey: QueryKey; action: string; invalidate: boolean } => {
  const last = mutationKey[mutationKey.length - 1] as AnyshiftMutationKeyItem;

  return {
    queryKey: mutationKey.slice(0, -1),
    action: last.action,
    invalidate: last.invalidate,
  };
};
